import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import './style.css'

const ContactForm = () => {

    const [forms, setForms] = useState({
        name: '',
        organization: '',
        designation: '',
        email: '',
        phone: '',
        interest: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = e => {
        e.preventDefault();
        if (validator.allValid()) {
            validator.hideMessages();
            setForms({
                name: '',
                organization: '',
                designation: '',
                email: '',
                phone: '',
                interest: '',
                message: ''
            })
        } else {
            validator.showMessages();
        }
    };

    const interestOptions = [
        'Educational Events & Speaking Engagements',
        'Edupreneur Opportunities',
        'University Partnerships',
    ];

    return (
        <form method="post" className="contact-form-inner contact-validation-active" onSubmit={submitHandler}>
            <h4 className="contact-form-heading">Tell Us How We Can Help</h4>
            <div className="row">
                <div className="col-md-6 col-12">
                    <div className="contact-field">
                        <label>Full Name*</label>
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your Full Name" />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col-md-6 col-12">
                    <div className="contact-field">
                        <label>Organization Name</label>
                        <input
                            value={forms.organization}
                            type="text"
                            name="organization"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your Organization" />
                    </div>
                </div>
                <div className="col-md-6 col-12">
                    <div className="contact-field">
                        <label>Designation</label>
                        <input
                            value={forms.designation}
                            type="text"
                            name="designation"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your Designation" />
                    </div>
                </div>
                <div className="col-md-6 col-12">
                    <div className="contact-field">
                        <label>Email Address*</label>
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your Email Address" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col-md-6 col-12">
                    <div className="contact-field">
                        <label>Mobile Number*</label>
                        <input
                            value={forms.phone}
                            type="tel"
                            name="phone"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your Mobile Number" />
                        {validator.message('phone', forms.phone, 'required')}
                    </div>
                </div>
                <div className="col-12">
                    <div className="contact-field">
                        <label>I Am Interested In</label>
                        <div className="contact-radio-group">
                            {interestOptions.map((option) => (
                                <label key={option} className="contact-radio-label">
                                    <input
                                        type="radio"
                                        name="interest"
                                        value={option}
                                        checked={forms.interest === option}
                                        onChange={changeHandler}
                                        className="contact-radio-input"
                                    />
                                    <span className="contact-radio-mark"></span>
                                    {option}
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="contact-field">
                        <label>Additional Message</label>
                        <textarea
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            value={forms.message}
                            name="message"
                            placeholder="Tell us how we can help...">
                        </textarea>
                    </div>
                </div>
                <div className="col-12">
                    <div className="contact-submit">
                        <button type="submit" className="theme-btn">Let's Connect</button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default ContactForm;
